<template>
  <div>
    <div>
      <b-container class="px-0 bg-white-border">
        <div class="p-3">
          <div class="header-container">
            <div class="mr-2">
              <b-button-group class="buttongroup-custom w-100">
                <b-button
                  v-if="switchViewId != 2"
                  :class="[
                    tabIndex === 4 ? 'button-active' : 'button-unactive',
                  ]"
                  @click="onClickTab(4)"
                  >Hour</b-button
                >
                <b-button
                  :class="[
                    tabIndex === 1 ? 'button-active' : 'button-unactive',
                  ]"
                  @click="onClickTab(1)"
                  >Day</b-button
                >
                <b-button
                  :class="[
                    tabIndex === 2 ? 'button-active' : 'button-unactive',
                  ]"
                  @click="onClickTab(2)"
                  >Week</b-button
                >
                <b-button
                  :class="[
                    tabIndex === 3 ? 'button-active' : 'button-unactive',
                  ]"
                  @click="onClickTab(3)"
                  >Month</b-button
                >
              </b-button-group>
            </div>
            <div
              class="d-flex align-items-center justify-content-between mb-2 my-md-0"
            >
              <span class="f-size-12">DATE: FORM </span>
              <div class="date-container">
                <datetime
                  class="date-picker"
                  value-zone="Asia/Bangkok"
                  placeholder="yyyy-mm-dd"
                  v-model="filter.startDate"
                  @close="onSelectDate"
                ></datetime>
              </div>
              <span class="f-size-12"> TO </span>
              <div class="date-container mr-0">
                <datetime
                  class="date-picker"
                  value-zone="Asia/Bangkok"
                  placeholder="yyyy-mm-dd"
                  v-model="filter.endDate"
                  @close="onSelectDate"
                ></datetime>
              </div>
              <b-dropdown
                id="dropdown-filter"
                variant="outline"
                right
                ref="dropdownfilter"
                class="filter-custom"
                no-flip
              >
                <template v-slot:button-content>
                  <font-awesome-icon icon="filter" class="mr-2" />FILTER
                </template>
                <div>
                  <p class="mb-2 dropdown-date-custom-text">Channel</p>
                </div>
                <b-dropdown-divider></b-dropdown-divider>
                <div>
                  <div class="input-flex-container">
                    <div
                      class="w-100 text-center my-2"
                      v-if="isLoadingPlatformConfigList"
                    >
                      <b-spinner small></b-spinner>
                    </div>
                    <div v-else>
                      <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-checkbox
                          v-for="option in platformConfigList"
                          v-model="filter.platformConfigId"
                          :key="`platformConfigId-${option.platformConfigId}`"
                          :value="option.platformConfigId"
                          :aria-describedby="ariaDescribedby"
                        >
                          <img
                            width="15"
                            height="15"
                            :src="option.imageUrl"
                            alt=""
                          />
                          {{ option.name }}
                        </b-form-checkbox>
                      </b-form-group>
                    </div>
                  </div>

                  <template v-if="conversationTopics.length">
                    <div>
                      <p class="mb-2 dropdown-date-custom-text">Topic</p>
                    </div>
                    <b-dropdown-divider></b-dropdown-divider>
                    <div>
                      <div class="input-flex-container mb-2">
                        <div class="w-100">
                          <!-- <div v-for="topic in conversationTopics">
                            <p v-if="topic.groupName">{{ topic.groupName }}</p>
                            <b-form-checkbox-group
                              v-model="filter.topicId"
                              :options="topic.topics"
                              class="mb-3"
                              value-field="id"
                              text-field="name"
                            ></b-form-checkbox-group>
                          </div> -->

                          <multiselect
                            id="topics-dropdown"
                            v-model="filter.topicArr"
                            :options="conversationTopicsFilter"
                            :multiple="true"
                            :group-select="false"
                            :close-on-select="false"
                            placeholder="Select Topic"
                            track-by="id"
                            label="name"
                            :option-disabled="(option) => option.isGroup"
                          >
                            <!-- @input="onSelectOption" -->
                            <template v-slot:noResult>ไม่พบข้อมูล</template>
                            <template #option="{ option }">
                              <div
                                v-if="option.isGroup"
                                class="group-header"
                                @mousedown.prevent
                                @click.prevent.stop="
                                  toggleGroup(option.groupName)
                                "
                              >
                                <div class="group-name">
                                  {{ option.groupName }}
                                </div>
                                <div class="group-icon">
                                  {{
                                    topicsGroups.includes(option.groupName)
                                      ? "▼"
                                      : "►"
                                  }}
                                </div>
                              </div>
                              <div
                                :class="
                                  !option.isGroup &&
                                  option.groupName &&
                                  !topicsGroups.includes(option.groupName)
                                    ? 'group-item'
                                    : 'item'
                                "
                              >
                                {{ option.name }}
                              </div>
                            </template>
                          </multiselect>
                          <div
                            class="d-flex justify-content-between multiselect__bottom"
                          >
                            <span class="count-selected"
                              >Selected : {{ filter.topicArr.length }}</span
                            >
                            <span class="clear" @click="filter.topicArr = []"
                              >Clear</span
                            >
                          </div>
                          <!-- <b-dropdown-divider></b-dropdown-divider> -->
                        </div>
                      </div>
                    </div>
                  </template>
                  <div>
                    <p class="mb-2 dropdown-date-custom-text">Search</p>
                  </div>
                  <b-dropdown-divider></b-dropdown-divider>
                  <div class="mt-2">
                    <multiselect
                      :close-on-select="false"
                      :clear-on-select="false"
                      multiple
                      v-model="filter.teamRoleMappingIdArr"
                      :options="teams"
                      placeholder="Select Team"
                      track-by="roleMappingId"
                      label="name"
                    ></multiselect>
                    <div
                      class="d-flex justify-content-between multiselect__bottom"
                    >
                      <span class="count-selected"
                        >Selected :
                        {{ filter.teamRoleMappingIdArr.length }}</span
                      >
                      <span
                        class="clear"
                        @click="filter.teamRoleMappingIdArr = []"
                        >Clear</span
                      >
                    </div>
                  </div>
                  <b-dropdown-divider></b-dropdown-divider>
                  <div class="mt-2">
                    <multiselect
                      :close-on-select="false"
                      :clear-on-select="false"
                      multiple
                      v-model="filter.agentGuidArr"
                      :options="agents"
                      placeholder="Select Agent"
                      track-by="userGUID"
                      label="agentName"
                    ></multiselect>
                    <div
                      class="d-flex justify-content-between multiselect__bottom"
                    >
                      <span class="count-selected"
                        >Selected : {{ filter.agentGuidArr.length }}</span
                      >
                      <span class="clear" @click="filter.agentGuidArr = []"
                        >Clear</span
                      >
                    </div>
                  </div>
                  <div class="mt-3">
                    <b-button class="w-100 submit-button" @click="getAllData">
                      <div>
                        <span> Search </span>
                      </div>
                    </b-button>
                  </div>
                </div>
              </b-dropdown>
            </div>
          </div>

          <div class="my-4">
            <b-row class="no-gutters">
              <b-col cols="12" sm>
                <div class="m-0 mb-4 mb-sm-0 mr-sm-1 stat-container">
                  <p>Total Chat Created</p>
                  <span class="number">{{
                    widgetData.totalCreatedChat | numeral("0,0")
                  }}</span>
                </div>
              </b-col>
              <b-col cols="12" sm>
                <div class="m-0 mb-4 mb-sm-0 mx-sm-1 stat-container">
                  <p>Total Chat Closed</p>
                  <span class="number">{{
                    widgetData.totalClosedChat | numeral("0,0")
                  }}</span>
                </div>
              </b-col>
              <b-col cols="12" sm>
                <div class="m-0 mb-4 mb-sm-0 mx-sm-1 stat-container">
                  <p>Total Customer</p>
                  <span class="number">{{
                    widgetData.totalCustomer | numeral("0,0")
                  }}</span>
                </div>
              </b-col>
              <b-col cols="12" sm="3">
                <div class="mr-0 mb-4 mb-sm-0 mx-sm-1 stat-container">
                  <p>Avg. Resolution Time</p>
                  <span class="number">{{
                    secsToTime(widgetData.avgResolution)
                  }}</span>
                </div>
              </b-col>
              <b-col cols="12" sm>
                <div class="m-0 mb-4 mb-sm-0 ml-sm-1 stat-container">
                  <p>Avg. Wait Time</p>
                  <span class="number">{{
                    secsToTime(widgetData.avgWaitTime)
                  }}</span>
                </div>
              </b-col>
            </b-row>
          </div>

          <b-row class="no-gutters my-3">
            <b-col cols="12" class="mb-3 mb-xl-0 text-right">
              <button class="create-button ml-2" @click="onSwitchView">
                Switch View
              </button>
            </b-col>
          </b-row>

          <b-row v-if="switchViewId == 1" class="no-gutters my-3">
            <b-col cols="12" xl="6" class="">
              <div class="mr-xl-2 row-container p-3 h-100">
                <div class="mb-2 d-flex justify-content-between">
                  <strong>CHAT</strong>
                  <b-button @click="exportExcel(1)" variant="export">
                    <div>
                      <!-- <font-awesome-icon icon="file-export" /> -->
                      <span>Export</span>
                    </div>
                  </b-button>
                </div>
                <div v-if="isChatLoading">
                  <div class="text-center">
                    <img
                      src="@/assets/images/icons/loading.svg"
                      alt="loading"
                      class="mb-3 img"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
                <div v-else class="mt-3">
                  <ChatChart
                    :data="dataChat"
                    :yAxisTitle="yAxisTitle"
                    :maxValue="maxValueChat"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="12" xl="6">
              <div class="ml-xl-2 row-container p-3 h-100">
                <div class="mb-2 d-flex justify-content-between">
                  <strong>CUSTOMER</strong>
                  <b-button @click="exportExcel(8)" variant="export">
                    <div>
                      <!-- <font-awesome-icon icon="file-export" /> -->
                      <span>Export</span>
                    </div>
                  </b-button>
                </div>
                <div v-if="isCustomerActivityLoading">
                  <div class="text-center">
                    <img
                      src="@/assets/images/icons/loading.svg"
                      alt="loading"
                      class="mb-3 img"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
                <div v-else class="mt-3">
                  <CustomerActivityChart
                    :data="dataCustomerActivity"
                    :yAxisTitle="yAxisTitle"
                    :maxValue="maxValueCustomerActivity"
                  />
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row v-else-if="switchViewId == 2" class="no-gutters my-3">
            <b-col cols="12" class="mb-3 mb-xl-0 row-container">
              <div class="mr-xl-2 bg-white p-3">
                <div class="d-flex justify-content-between">
                  <strong>All Channel Activity Overview</strong>
                  <b-button @click="exportExcel(7)" variant="export">
                    <div>
                      <span>Export</span>
                    </div>
                  </b-button>
                </div>
                <div v-if="isChannelActivity">
                  <div class="text-center">
                    <img
                      src="@/assets/images/icons/loading.svg"
                      alt="loading"
                      class="mb-3 img"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
                <div
                  v-else
                  class="mt-3 chart-h-heatmap"
                  :style="{
                    height: dataChannelActivity.rows * 50 + 100 + 'px',
                  }"
                >
                  <JSCharting
                    :options="chartChannelActivityOptions"
                    v-if="!isChannelActivity"
                    ref="chart01"
                  ></JSCharting>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="no-gutters my-3">
            <b-col cols="12" xl="6">
              <div class="mr-xl-2 row-container p-3 h-100">
                <div class="mb-2 d-flex justify-content-between">
                  <strong>Conversation Topic</strong>
                  <b-button @click="exportExcel(2)" variant="export">
                    <div>
                      <!-- <font-awesome-icon icon="file-export" /> -->
                      <span>Export</span>
                    </div>
                  </b-button>
                </div>
                <div v-if="isConversationTopicLoading">
                  <div class="text-center">
                    <img
                      src="@/assets/images/icons/loading.svg"
                      alt="loading"
                      class="mb-3 img"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
                <div v-else class="mt-3">
                  <ConversationTopicChart
                    :data="dataConversationTopic"
                    :data2="dataConversationTopicCustomer"
                    id="conversation-topic"
                    :yAxisTitle="yAxisTitle"
                    :maxValue="maxValueConversationTopic"
                    textX="Conversation Topic"
                    textX2="Customer"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="12" xl="6">
              <div class="ml-xl-2 row-container p-3 h-100">
                <div class="mb-2 d-flex justify-content-between">
                  <strong>Chat Created by Source</strong>
                  <b-button @click="exportExcel(3)" variant="export">
                    <div>
                      <!-- <font-awesome-icon icon="file-export" /> -->
                      <span>Export</span>
                    </div>
                  </b-button>
                </div>
                <div v-if="isChatSourceLoading">
                  <div class="text-center">
                    <img
                      src="@/assets/images/icons/loading.svg"
                      alt="loading"
                      class="mb-3 img"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
                <div v-else class="mt-3">
                  <ConversationTopicChart
                    :data="dataChatSource"
                    :data2="dataChatSourceCustomer"
                    id="BarChartChatSource"
                    :yAxisTitle="yAxisTitle"
                    :maxValue="maxValueChatSource"
                    textX="Channel"
                    textX2="Customer"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="no-gutters my-3">
            <b-col cols="12" xl="6">
              <div class="mr-xl-2 row-container p-3 h-100">
                <div class="mb-2 d-flex justify-content-between">
                  <strong>Wait Time</strong>
                  <b-button @click="exportExcel(4)" variant="export">
                    <div>
                      <!-- <font-awesome-icon icon="file-export" /> -->
                      <span>Export</span>
                    </div>
                  </b-button>
                </div>
                <div v-if="isWaitTimeLoading">
                  <div class="text-center">
                    <img
                      src="@/assets/images/icons/loading.svg"
                      alt="loading"
                      class="mb-3 img"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
                <div v-else class="mt-3">
                  <BarChartWaitTime
                    :data="dataWaitTime"
                    id="wait-time"
                    :yAxisTitle="yAxisTitle"
                    :maxValue="maxValueWaitTime"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="12" xl="6">
              <div class="ml-xl-2 row-container p-3 h-100">
                <div class="mb-2 d-flex justify-content-between">
                  <strong>Resolution Time</strong>
                  <b-button @click="exportExcel(5)" variant="export">
                    <div>
                      <!-- <font-awesome-icon icon="file-export" /> -->
                      <span>Export</span>
                    </div>
                  </b-button>
                </div>
                <div v-if="isResolutionTimeLoading">
                  <div class="text-center">
                    <img
                      src="@/assets/images/icons/loading.svg"
                      alt="loading"
                      class="mb-3 img"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
                <div v-else class="mt-3">
                  <ResolutionTimeChart
                    :data="dataResolutionTime"
                    id="resolution-time"
                    :yAxisTitle="yAxisTitle"
                    :maxValue="maxValueResolutionTime"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row
            class="no-gutters my-3"
            v-if="getBrandDetail().surveyUrlEnable"
          >
            <b-col cols="12" xl="6">
              <div class="mr-xl-2 row-container p-3 h-100">
                <div class="mb-2 d-flex justify-content-between flex-wrap">
                  <strong>CUSTOMER SATISFACTION OVERALL RATING</strong>
                  <b-button @click="exportExcel(10)" variant="export">
                    <span>Export</span>
                  </b-button>
                </div>
                <div v-if="isLoadingOverAllRating">
                  <div class="text-center">
                    <img
                      src="@/assets/images/icons/loading.svg"
                      alt="loading"
                      class="mb-3 img"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
                <GaugeChart
                  v-else
                  :percentValue="overAllRating.overAllRatingPercent"
                  :rating="overAllRating.overAllRating"
                />
              </div>
            </b-col>
            <b-col cols="12" xl="6">
              <div class="ml-xl-2 row-container p-3 h-100">
                <div class="mb-2 d-flex justify-content-between flex-wrap">
                  <strong>SURVEY ENGAGEMENT RATING</strong>
                  <b-button @click="exportExcel(9)" variant="export">
                    <span>Export</span>
                  </b-button>
                </div>
                <div v-if="isLoadingSurveyEngagement">
                  <div class="text-center">
                    <img
                      src="@/assets/images/icons/loading.svg"
                      alt="loading"
                      class="mb-3 img"
                      width="50px"
                      height="50px"
                    />
                  </div>
                </div>
                <SurveyEngagementChart
                  v-else
                  :data="dataSendSurvey"
                  :data2="dataAnswerSurvey"
                  id="BarChartSurveyEngagement"
                  :yAxisTitle="yAxisTitle"
                  textX="Send"
                  textX2="Replied"
                />
              </div>
            </b-col>
          </b-row>
          <div class="mt-4">
            <div class="d-flex justify-content-between">
              <h2 class="font-weight-bold">Agent Performance Report</h2>
              <b-button @click="exportExcel(6)" variant="export">
                <div>
                  <!-- <font-awesome-icon icon="file-export" /> -->
                  <span>Export</span>
                </div>
              </b-button>
            </div>
            <b-row class="main-theme no-gutters mb-3">
              <b-col class="mt-3 w-100">
                <b-table
                  responsive
                  striped
                  hover
                  class="table-list hide-icon-sort"
                  :items="agentPerformanceList"
                  :fields="fields"
                  :busy="isBusy"
                  show-empty
                  :empty-text="$t('noData')"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                >
                  <template v-slot:table-busy>
                    <div class="text-center text-black my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong class="ml-2">Loading...</strong>
                    </div>
                  </template>
                  <template #head()="data">
                    <span>{{ data.label }}</span>
                    <font-awesome-icon
                      v-if="data.field.sortable"
                      icon="sort-up"
                      class="sort-icon up"
                    />
                    <font-awesome-icon
                      v-if="data.field.sortable"
                      icon="sort-down"
                      class="sort-icon down"
                    />
                  </template>
                  <template v-slot:cell(chatCreated)="data">
                    <span>
                      {{ data.item.chatCreated | numeral("0,0") }}
                    </span>
                  </template>
                  <template v-slot:cell(chatClosed)="data">
                    <span>
                      {{ data.item.chatClosed | numeral("0,0") }}
                    </span>
                  </template>
                  <template v-slot:cell(avgFirstResponseTimeSec)="data">
                    <span>
                      {{ data.item.avgFirstResponseTime }}
                    </span>
                  </template>
                  <template v-slot:cell(avgResolutionTimeSec)="data">
                    <span>
                      {{ data.item.avgResolutionTime }}
                    </span>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row class="no-gutters px-3 px-sm-0">
              <b-col
                class="form-inline justify-content-center justify-content-sm-between"
              >
                <div v-if="rows > 0" class="my-auto">
                  Showing {{ startPage | numeral("0,0") }} to
                  {{ endPage | numeral("0,0") }} of
                  {{ rows | numeral("0,0") }} entires
                </div>
                <div v-else class="my-auto">{{ rows }} entire</div>
                <div class="d-sm-flex mx-3 mx-md-0">
                  <b-pagination
                    v-model="filterAgentPerformance.pageNo"
                    :total-rows="rows"
                    :per-page="filterAgentPerformance.perPage"
                    class="m-md-0"
                    @change="pagination"
                    align="center"
                  ></b-pagination>
                  <b-form-select
                    class="select-pagination ml-md-3 w-auto"
                    v-model="filterAgentPerformance.perPage"
                    @change="handleChangePerpage"
                    :options="pageOptions"
                  ></b-form-select>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-container>
    </div>
    <ModalLoading ref="modalLoading" :text="msgModal" :hasClose="false" />
  </div>
</template>

<script>
import BarChartChatSource from "./components/BarChartChatSource.vue";
import BarChartWaitTime from "./components/BarChartTime.vue";
import ChatChart from "./components/ChatChart.vue";
import CustomerActivityChart from "./components/CustomerActivityChart.vue";
import ResolutionTimeChart from "./components/BarChartTime.vue";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ConversationTopicChart from "./components/BarChartTime.vue";
import SurveyEngagementChart from "./components/BarChartSurveyEngagement.vue";
import moment from "moment";
import Multiselect from "vue-multiselect";
import JSCharting from "jscharting-vue";
import GaugeChart from "./components/GaugeChart";
import HorizontalBarChart from "./components/HorizontalBarChart";
import { mapGetters } from "vuex";

export default {
  components: {
    BarChartChatSource,
    BarChartWaitTime,
    ChatChart,
    CustomerActivityChart,
    ResolutionTimeChart,
    ModalLoading,
    ConversationTopicChart,
    SurveyEngagementChart,
    Multiselect,
    JSCharting,
    GaugeChart,
    HorizontalBarChart,
  },
  name: "Chart",
  data: function () {
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    startDate.setUTCHours(0, 0, 0, 0);
    const endDate = new Date();
    endDate.setUTCHours(0, 0, 0, 0);
    return {
      isChannelActivity: true,
      isChatLoading: true,
      isCustomerActivityLoading: true,
      isConversationTopicLoading: true,
      isChatSourceLoading: true,
      isWaitTimeLoading: true,
      isResolutionTimeLoading: true,
      maxValueResolutionTime: 0,
      maxValueConversationTopic: 10,
      maxValueWaitTime: 0,
      maxValueChatSource: 0,
      maxValueChat: 0,
      dataChannelActivity: {
        rows: 0,
      },
      isLoadingOverAllRating: true,
      overAllRating: {
        overAllRating: 0,
        overAllRatingPercent: 0,
      },
      maxValueCustomerActivity: 0,
      dataChat: {
        chatCreated: [],
        chatClosed: [],
      },
      dataCustomerActivity: {
        chatCreated: [],
      },
      dataChatSource: [],
      dataChatSourceCustomer: [],
      dataSendSurvey: [],
      dataAnswerSurvey: [],
      dataConversationTopic: [
        {
          name: "สั่งสินค้า",
          count: 3,
        },
        {
          name: "ถามราคาสินค้า",
          count: 4,
        },
        {
          name: "ตามสินค้า",
          count: 6,
        },
        {
          name: "ถามสต๊อกสินค้า",
          count: 8,
        },
        {
          name: "ขอราคาพิเศษ",
          count: 9,
        },
      ],
      dataConversationTopicCustomer: [
        {
          name: "สั่งสินค้า",
          count: 3,
        },
        {
          name: "ถามราคาสินค้า",
          count: 4,
        },
        {
          name: "ตามสินค้า",
          count: 6,
        },
        {
          name: "ถามสต๊อกสินค้า",
          count: 8,
        },
        {
          name: "ขอราคาพิเศษ",
          count: 9,
        },
      ],
      dataWaitTime: [],
      dataResolutionTime: [],
      startDate: "",
      yAxisTitle: "Week",
      endDate: "",
      tabIndex: 2,
      filter: {
        startDate: "",
        endDate: "",
        ViewAs: 2,
        channelId: [],
        topicId: [],
        topicArr: [],
        agentGuid: [],
        agentGuidArr: [],
        teamRoleMappingIds: [],
        teamRoleMappingIdArr: [],
        platformConfigId: [],
      },
      widgetData: {
        avgResolution: 0,
        avgWaitTime: 0,
      },
      channelList: [],
      isLoadingChannelList: false,
      isLoadingSurveyEngagement: true,
      platformConfigList: [],
      isLoadingPlatformConfigList: false,
      conversationTopics: [],
      topicsGroups: [],
      fields: [
        {
          key: "agentName",
          label: "Agent Name",
          sortable: true,
        },
        {
          key: "chatCreated",
          label: "Chat Created",
          class: "w-100px",
          sortable: true,
        },
        {
          key: "chatClosed",
          label: "Chat Closed",
          class: "w-100px",
          sortable: true,
        },
        {
          key: "avgFirstResponseTimeSec",
          label: "Avg. Frist Response Time",
          class: "w-100px",
          sortable: true,
        },
        {
          key: "avgResolutionTimeSec",
          label: "Avg. Resolution Time",
          class: "w-100px",
          sortable: true,
        },
      ],
      filterAgentPerformance: {
        startDate: "",
        endDate: "",
        ViewAs: 2,
        channelId: [],
        topicId: [],
        topicArr: [],
        agentGuid: [],
        agentGuidArr: [],
        teamRoleMappingIds: [],
        teamRoleMappingIdArr: [],
        platformConfigId: [],
        pageNo: 1,
        perPage: 10,
        sortById: 1,
      },
      pageOptions: [
        { value: 10, text: `10 / Page` },
        { value: 30, text: `30 / Page` },
        { value: 50, text: `50 / Page` },
        { value: 100, text: `100 / Page` },
      ],
      isBusy: false,
      rows: 0,
      startPage: 1,
      endPage: 10,
      agentPerformanceList: [],
      msgModal: null,
      modalMessage: "",
      sortBy: "agentName",
      sortDesc: false,
      agents: [],
      isLoadingAgent: false,
      teams: [],
      isLoadingTeam: false,
      switchViewId: 1,
      chartChannelActivityOptions: {
        debug: true,
        id: "chat-chart",
        type: "heatmap",
        toolbar_visible: false,
        legend: {
          position: "middle right",
          // title_label_text: "Total Chat",
          // position: 'bottom',
          // layout: "horizontal",
          // defaultEntry_icon_width: 10
        },
        palette: {
          // colors: ["#ffffff", "#68cbbb"],
          pointValue: "{%zValue}",
          stops: [
            [0, "#ffffff"],
            [30, "#68cbbb"],
          ],
          colorsValueRange: [0, 30],
          // ranges: {
          //   // min: 0,
          //   // max: 30,
          //   // interval: 6
          // }
        },
        defaultPoint: {
          tooltip: "<b>%yValue</b> (%xValue)<br/>Total Chat: %zValue",
          label_text: "%zValue",
          outline_width: 0,
          outline_color: "none",
          // hoverAction: false
        },
        zAxis_label_text: "",
        xAxis: {
          label_text: "Time",
          autoRotate: -45,
        },
        yAxis: {
          label_text: "Days",
        },
        series: [
          {
            name: "chat-chart",
            points: [],
          },
        ],
      },
    };
  },
  watch: {
    sortBy(newValue, oldValue) {
      this.handleSorting("filterAgentPerformance", newValue);
    },
    sortDesc(newValue, oldValue) {
      this.handleSorting(
        "filterAgentPerformance",
        this.filterAgentPerformance.sortBy,
        newValue
      );
    },
  },
  methods: {
    getChannelActivity: async function () {
      this.isChannelActivity = true;
      const url = `${this.$baseUrl}/analytics/Chat/HeatMap`;
      await this.axios
        .post(url, this.filter)
        .then(async (data) => {
          if (data.result === 1) {
            await this.convertDataHeatmap(data.detail, "ChannelActivity");
            this.isChannelActivity = false;
          }
        })
        .catch((error) => {
          this.isChannelActivity = false;
        });
    },
    async convertDataHeatmap(res, key) {
      let max = res.max || 1;
      this[`data${key}`].rows = res.chatDates.length || 0;
      this[`chart${key}Options`].palette.colorsValueRange = [0, max];
      let points = [];
      var totalPerTime = [];
      var totalPerDay = [];

      for (const data of res.data) {
        points.unshift({
          y: data.chatDate,
          x: data.time,
          z: data.count,
        });
      }

      for (const time of res.times) {
        totalPerTime.push({
          y: `Total Time`,
          x: time,
          z: res.totalPerTime[time],
          color: "#797979",
        });
      }

      totalPerTime.push({
        y: `Total Time`,
        x: `Total Days`,
        z: res.grandTotal,
        color: "#555555",
      });

      for (const day of res.chatDates) {
        let total = res.totalPerChatDate[day] || 0;
        totalPerDay.push({
          x: `Total Days`,
          y: day,
          z: total,
          color: "#797979",
        });
      }

      points = [...totalPerTime, ...points, ...totalPerDay];

      this[`chart${key}Options`].palette.stops = [
        [0, "#ffffff"],
        [max, "#68cbbb"],
      ];
      this[`chart${key}Options`].series[0].points = points;
    },
    async handleSorting(key, sortBy, sortDesc = false) {
      if (sortBy == "agentName") {
        this[key].sortById = sortDesc ? 2 : 1;
      } else if (sortBy == "chatCreated") {
        this[key].sortById = sortDesc ? 4 : 3;
      } else if (sortBy == "chatClosed") {
        this[key].sortById = sortDesc ? 6 : 5;
      } else if (sortBy == "avgFirstResponseTimeSec") {
        this[key].sortById = sortDesc ? 8 : 7;
      } else if (sortBy == "avgResolutionTimeSec") {
        this[key].sortById = sortDesc ? 10 : 9;
      }
      await this.getAgentPerformanceReport();
    },

    onSelectDate() {
      if (this.filter.startDate && this.filter.endDate) {
        this.getAllData();
      }
    },
    getChat: async function () {
      this.isChatLoading = true;
      const url = `${this.$baseUrl}/analytics/chat`;
      await this.axios
        .post(url, this.filter)
        .then(async (data) => {
          if (data.result === 1) {
            let dataLists =
              data.detail.chatLists.length > 0 ? data.detail.chatLists : [];

            const chatCreated = dataLists.map((e) => {
              return {
                name: e.chatDate,
                count: e.chatCreated,
                countFormat: e.chatCreated,
                total: e.total,
                percent: e.chatOpenPercent,
              };
            });
            const chatClosed = dataLists.map((e) => {
              return {
                name: e.chatDate,
                count: e.chatClosed,
                countFormat: e.chatClosed,
                total: e.total,
                percent: e.chatClosedPercent,
              };
            });
            const dataResult = {
              chatCreated,
              chatClosed,
            };
            let max = await Math.max(
              ...dataLists.map((o) =>
                o.chatCreated > o.chatClosed ? o.chatCreated : o.chatClosed
              )
            );
            this.maxValueChat = Math.round(max + max / 5);
            this.maxValueChat = this.maxValueChat < 5 ? 4 : this.maxValueChat;
            this.dataChat = dataResult;
            this.isChatLoading = false;
          }
        })
        .catch((error) => {
          this.dataChat = {};
          this.isChatLoading = false;
        });
    },
    getCustomerActivity: async function () {
      this.isCustomerActivityLoading = true;
      const url = `${this.$baseUrl}/analytics/CustomerActivity`;
      await this.axios
        .post(url, this.filter)
        .then(async (data) => {
          if (data.result === 1) {
            let dataLists =
              data.detail.customerLists.length > 0
                ? data.detail.customerLists
                : [];

            const customer = dataLists.map((e) => {
              return {
                name: e.customerDate,
                count: e.customerCount,
                countFormat: e.customerDate,
                total: e.customerCount,
                percent: 0,
              };
            });

            const dataResult = {
              customer,
            };
            let max = await Math.max(
              ...dataLists.map((o) =>
                o.chatCreated > o.chatClosed ? o.chatCreated : o.chatClosed
              )
            );
            this.maxValueCustomerActivity = Math.round(max + max / 5);
            this.maxValueCustomerActivity =
              this.maxValueCustomerActivity < 5
                ? 4
                : this.maxValueCustomerActivity;
            this.dataCustomerActivity = dataResult;
            this.isCustomerActivityLoading = false;
          }
        })
        .catch((error) => {
          this.dataCustomerActivity = {};
          this.isCustomerActivityLoading = false;
        });
    },
    getConversationTopic: async function () {
      this.isConversationTopicLoading = false;
      this.isConversationTopicLoading = true;
      const url = `${this.$baseUrl}/analytics/Topic-2`;
      await this.axios
        .post(url, this.filter)
        .then(async (data) => {
          if (data.result === 1) {
            const dataLists =
              data.detail.numberChat.length > 0 ? data.detail.numberChat : [];
            const dataListsCustomer =
              data.detail.numberCustomer.length > 0
                ? data.detail.numberCustomer
                : [];

            //
            const chartDatas = dataLists.map((e) => {
              return {
                id: e.id,
                count: e.count,
                name: e.name,
              };
            });
            const chartDatasCustomer = dataListsCustomer.map((e) => {
              return {
                id: e.id,
                count: e.count,
                name: e.name,
              };
            });

            // topic
            let max = await Math.max(...chartDatas.map((o) => o.count));
            this.maxValueConversationTopic = Math.round(max + max / 5);

            // customer
            let maxCustomer = await Math.max(
              ...chartDatasCustomer.map((o) => o.count)
            );
            let maxValueConversationTopicCustomer = Math.round(
              maxCustomer + maxCustomer / 5
            );

            if (
              maxValueConversationTopicCustomer > this.maxValueConversationTopic
            ) {
              this.maxValueConversationTopic =
                maxValueConversationTopicCustomer;
            }

            this.maxValueConversationTopic =
              this.maxValueConversationTopic < 5
                ? 4
                : this.maxValueConversationTopic;

            this.dataConversationTopic = chartDatas;
            this.dataConversationTopicCustomer = chartDatasCustomer;

            this.isConversationTopicLoading = false;
          }
        })
        .catch((error) => {
          this.dataConversationTopic = [];
          this.dataConversationTopicCustomer = [];
          this.isConversationTopicLoading = false;
        });
    },
    getChatSource: async function () {
      this.isChatSourceLoading = true;
      const url = `${this.$baseUrl}/analytics/ChatSource-2`;
      await this.axios
        .post(url, this.filter)
        .then(async (data) => {
          if (data.result === 1) {
            const dataLists =
              data.detail.numberPlatform.length > 0
                ? data.detail.numberPlatform
                : [];
            const chartDatas = dataLists.map((e) => {
              return {
                id: e.id,
                count: e.count,
                name: e.name,
              };
            });

            const dataListsCustomer =
              data.detail.numberCustomer.length > 0
                ? data.detail.numberCustomer
                : [];
            const chartDatasCustomer = dataListsCustomer.map((e) => {
              return {
                id: e.id,
                count: e.count,
                name: e.name,
              };
            });

            let max = await Math.max(...chartDatas.map((o) => o.count));
            this.maxValueChatSource = Math.round(max + max / 5);

            // customer
            let maxCustomer = await Math.max(
              ...chartDatasCustomer.map((o) => o.count)
            );
            let maxValueChatSourceCustomer = Math.round(
              maxCustomer + maxCustomer / 5
            );
            if (maxValueChatSourceCustomer > this.maxValueChatSource) {
              this.maxValueChatSource = maxValueChatSourceCustomer;
            }

            this.maxValueChatSource =
              this.maxValueChatSource < 5 ? 4 : this.maxValueChatSource;

            this.dataChatSource = chartDatas;
            this.dataChatSourceCustomer = chartDatasCustomer;

            this.isChatSourceLoading = false;
          }
        })
        .catch((error) => {
          this.dataChatSource = [];
          this.isChatSourceLoading = false;
        });
    },
    getWaitTime: async function () {
      this.isWaitTimeLoading = true;
      const url = `${this.$baseUrl}/analytics/WaitTime`;
      await this.axios
        .post(url, this.filter)
        .then(async (data) => {
          if (data.result === 1) {
            const dataLists = data.detail.length > 0 ? data.detail : [];
            const chartDatas = dataLists.map((e) => {
              return {
                percent: e.percent,
                percentFormat: e.percentFormat,
                name: e.name,
                count: e.count,
              };
            });
            let max = await Math.max(...chartDatas.map((o) => o.count));
            this.maxValueWaitTime = Math.round(max + max / 5);
            this.maxValueWaitTime =
              this.maxValueWaitTime < 5 ? 4 : this.maxValueWaitTime;
            //show only first 1-10 intent
            this.dataWaitTime = chartDatas.slice(0, 10);
            this.isWaitTimeLoading = false;
          }
        })
        .catch((error) => {
          this.dataWaitTime = [];
          this.isWaitTimeLoading = [];
        });
    },
    getResolutionTime: async function () {
      this.isResolutionTimeLoading = true;
      const url = `${this.$baseUrl}/analytics/Resolution`;
      await this.axios
        .post(url, this.filter)
        .then(async (data) => {
          if (data.result === 1) {
            const dataLists = data.detail.length > 0 ? data.detail : [];
            const chartDatas = dataLists.map((e) => {
              return {
                percent: e.percent,
                percentFormat: e.percentFormat,
                name: e.name,
                count: e.count,
              };
            });
            let max = await Math.max(...chartDatas.map((o) => o.count));
            this.maxValueResolutionTime = Math.round(max + max / 5);
            this.maxValueResolutionTime =
              this.maxValueResolutionTime < 5 ? 4 : this.maxValueResolutionTime;
            //show only first 1-10 intent
            this.dataResolutionTime = chartDatas.slice(0, 10);
            this.isResolutionTimeLoading = false;
          }
        })
        .catch((error) => {
          this.dataResolutionTime = {};
          this.isResolutionTimeLoading = false;
        });
    },
    onClickTab: async function (idx) {
      this.tabIndex = idx;
      this.filter.ViewAs = idx;
      if (idx == 1) {
        this.yAxisTitle = "Day";
        // this.filter.startDate = moment().subtract(1, "day").format();
      } else if (idx == 2) {
        this.yAxisTitle = "Week";
        // this.filter.startDate = moment().subtract(1, "week").format();
      } else if (idx == 3) {
        this.yAxisTitle = "Month";
        // this.filter.startDate = moment().subtract(1, "month").format();
      } else {
        this.yAxisTitle = "Hour";
        // this.filter.startDate = moment().subtract(1, "week").format();
      }

      // this.filter.endDate = moment().format();
      await this.getAllData();
    },
    getWidget: async function () {
      const url = `${this.$baseUrl}/analytics/Widget`;
      await this.axios.post(url, this.filter).then((data) => {
        if (data.result === 1) {
          this.widgetData = data.detail;
        }
      });
    },
    getAllPlatformConfig: async function () {
      const url = `${this.$baseUrl}/analytics/get-all-platform-config`;
      await this.axios.get(url).then(async (data) => {
        if (data.result === 1) {
          this.platformConfigList = data.detail;
        }
      });
    },
    getChannel: async function () {
      const url = `${this.$baseUrl}/analytics/Filter/Channel`;
      await this.axios.get(url).then(async (data) => {
        if (data.result === 1) {
          this.channelList = data.detail;
        }
      });
    },
    getConversationTopics: async function () {
      await this.axios(`${this.$baseUrl}/FlowBuilder/Topics`)
        .then((data) => {
          if (data.result === 1) {
            this.conversationTopics = data.detail;
          }
        })
        .catch((error) => {
          this.conversationTopics = [];
        });
    },
    getAgentPerformanceReport: async function () {
      this.isBusy = true;
      let filter = {
        DateStart: this.filter.startDate,
        DateEnd: this.filter.endDate,
        ViewAs: this.filter.ViewAs,
        channelId: this.filter.channelId,
        topicId: this.filter.topicId,
        agentGuid: this.filter.agentGuid,
        teamRoleMappingIds: this.filter.teamRoleMappingIds,
        pageNo: this.filterAgentPerformance.pageNo,
        perPage: this.filterAgentPerformance.perPage,
        Search: this.filter.Search,
        sortById: this.filterAgentPerformance.sortById,
        platformConfigId: this.filter.platformConfigId,
      };
      await this.axios
        .post(`${this.$baseUrl}/analytics/GetAgentPerformanceReport`, filter)
        .then((data) => {
          if (data.result === 1) {
            this.agentPerformanceList = data.detail.data;
            this.rows = data.detail.count;
            this.isBusy = false;
          }
        });
    },
    pagination(Page) {
      this.filterAgentPerformance.pageNo = Page;
      this.getAgentPerformanceReport();
      this.getShowingPage(Page);
    },
    handleChangePerpage(perPage) {
      this.filterAgentPerformance.pageNo = 1;
      this.filterAgentPerformance.perPage = perPage;
      this.showing = this.filterAgentPerformance.pageNo;
      this.showingTo = this.filterAgentPerformance.perPage;
      this.getAgentPerformanceReport();
      this.getShowingPage(this.filterAgentPerformance.pageNo);
    },
    async getShowingPage(page) {
      let result = await this.$getShowingPage(
        page,
        this.filterAgentPerformance
      );
      this.startPage = result.startPage;
      this.endPage = result.endPage;
    },
    getAllData: async function () {
      this.filter.startDate = moment(this.filter.startDate).format(
        "YYYY-MM-DDT00:00:00+07:00"
      );
      this.filter.endDate = moment(this.filter.endDate).format(
        "YYYY-MM-DDT23:59:59+07:00"
      );

      this.filter.topicId = await this.filter.topicArr.map((e) => e.id);

      this.filter.agentGuid = await this.filter.agentGuidArr.map(
        (e) => e.userGUID
      );
      this.filter.teamRoleMappingIds =
        await this.filter.teamRoleMappingIdArr.map((e) => e.roleMappingId);

      this.getChannelActivity();
      this.getChat();
      this.getCustomerActivity();
      this.getConversationTopic();
      this.getChatSource();
      this.getWaitTime();
      this.getResolutionTime();
      this.getWidget();
      this.getAgentPerformanceReport();
      if (this.getBrandDetail().surveyUrlEnable) {
        this.getGaugeOverAllRating();
        this.getSurveyEngagement();
      }
    },
    async getSurveyEngagement() {
      this.isLoadingSurveyEngagement = true;
      const url = `${this.$baseUrl}/analytics/SurveyEngagement`;
      const response = await this.axios.post(url, this.filter);
      if (response && response.result === 1 && response.detail) {
        this.dataSendSurvey = response.detail.countSend.map((e) => {
          return {
            id: e.platformConfigId,
            count: e.count,
            name: e.channelName,
          };
        });
        this.dataAnswerSurvey = response.detail.countAnswer.map((e) => {
          return {
            id: e.platformConfigId,
            count: e.count,
            name: e.channelName,
          };
        });
      }

      this.isLoadingSurveyEngagement = false;
    },
    async getGaugeOverAllRating() {
      this.isLoadingOverAllRating = true;

      const url = `${this.$baseUrl}/analytics/OverAllRating`;
      const response = await this.axios.post(url, this.filter);
      if (response && response.result === 1) {
        this.overAllRating = response.detail;
      }
      this.isLoadingOverAllRating = false;
    },
    async exportExcel(typeNumber) {
      this.$refs.modalLoading.show();
      this.msgModal = "In progress";

      const body = {
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
        ViewAs: this.filter.ViewAs,
        channelId: this.filter.channelId,
        topicId: this.filter.topicId,
        agentGuid: this.filter.agentGuid,
        teamRoleMappingIds: this.filter.teamRoleMappingIds,
        platformConfigId: this.filter.platformConfigId,
      };
      body.topicId = await this.filter.topicArr.map((e) => e.id);
      body.agentGuid = await this.filter.agentGuidArr.map((e) => e.userGUID);
      body.teamRoleMappingIds = await this.filter.teamRoleMappingIdArr.map(
        (e) => e.roleMappingId
      );

      let path = "";
      let fileName = "";

      if (typeNumber == 1) {
        path = "analytics/Chat/export";
        fileName = "Chat";
      } else if (typeNumber == 2) {
        path = "analytics/export/Topic-2";
        fileName = "Conversation_Topic";
      } else if (typeNumber == 3) {
        path = "analytics/export/ChatSource-2";
        fileName = "Chat_Created_by_Source";
      } else if (typeNumber == 4) {
        path = "analytics/export/WaitTime";
        fileName = "Wait_Time";
      } else if (typeNumber == 5) {
        path = "analytics/Resolution/export";
        fileName = "Resolution_Time";
      } else if (typeNumber == 6) {
        path = "analytics/GetAgentPerformanceReportExport";
        fileName = "Agent_Performance_Report";
        body.DateStart = this.filter.startDate;
        body.DateEnd = this.filter.endDate;
      } else if (typeNumber == 7) {
        path = "analytics/Chat/HeatMap/export";
        fileName = "All_Channel_Activity_Overview";
      } else if (typeNumber == 8) {
        path = "analytics/CustomerActivity/Export";
        fileName = "Customer_Activity_Report";
        body.DateStart = this.filter.startDate;
        body.DateEnd = this.filter.endDate;
      } else if (typeNumber == 9) {
        path = "analytics/SurveyEngagement/Export";
        fileName = "Survey_Engagement_Report";
        body.DateStart = this.filter.startDate;
        body.DateEnd = this.filter.endDate;
      } else if (typeNumber == 10) {
        path = "analytics/OverAllRating/Export";
        fileName = "OverAllRating_Report";
        body.DateStart = this.filter.startDate;
        body.DateEnd = this.filter.endDate;
      }
      try {
        await this.axios
          .post(`${this.$baseUrl}/${path}`, body, {
            responseType: "blob",
          })
          .then(async (response) => {
            this.$refs.modalLoading.hide();
            const isJsonBlob = (data) =>
              data instanceof Blob && data.type === "application/json";
            const responseData = isJsonBlob(response)
              ? await response?.text()
              : response || {};
            if (typeof responseData === "string") {
              const responseJson = JSON.parse(responseData);
              this.$refs.modalLoading.hide();
              this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
                isShow: true,
                msg: responseJson.message,
              });
            } else {
              var fileURL = window.URL.createObjectURL(new Blob([response]));
              var fileLink = document.createElement("a");
              var startDate = moment(this.filter.startDate).format("YYYYMMDD");
              var endDate = moment(this.filter.endDate).format("YYYYMMDD");

              fileLink.href = fileURL;
              fileLink.setAttribute(
                "download",
                `${fileName}_${startDate}-${endDate}.xlsx`
              );
              document.body.appendChild(fileLink);
              fileLink.click();
            }
          })
          .catch((error) => {
            console.log(error);
            this.$refs.modalLoading.hide();
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: error.message,
            });
          });
      } catch (err) {
        console.error(err);
        this.$refs.modalLoading.hide();
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: error.message,
        });
      }
    },
    secsToTime(secs) {
      let d = (secs / 8.64e4) | 0;
      let H = ((secs % 8.64e4) / 3.6e3) | 0;
      let m = ((secs % 3.6e3) / 60) | 0;
      let s = secs % 60;
      // let z = (n) => (n < 10 ? "0" : "") + n;
      let result = "";
      if (d) result += `${d}d `;
      if (H) result += `${H}h `;
      if (m) result += `${m}m `;
      result += `${Math.round(s)}s`;
      return result;
    },
    getAgents: async function () {
      this.isLoadingAgent = true;
      await this.axios(`${this.$baseUrl}/customer/list/Agent`)
        .then((data) => {
          if (data.result === 1) {
            this.agents = data.detail;
            this.isLoadingAgent = false;
          }
        })
        .catch((error) => {
          this.agents = [];
          this.isLoadingAgent = false;
        });
    },
    getTeams: async function () {
      this.isLoadingTeam = true;
      let body = {
        pageNo: 1,
        perPage: 999,
        search: "",
      };
      await this.axios
        .post(`${this.$baseUrl}/Team/list/name`, body)
        .then((data) => {
          if (data.result === 1) {
            this.teams = data.detail.data;
            this.isLoadingTeam = false;
          }
        })
        .catch((error) => {
          this.teams = [];
          this.isLoadingTeam = false;
        });
    },
    onSwitchView() {
      if (this.tabIndex === 4) this.onClickTab(2);
      this.switchViewId = this.switchViewId == 1 ? 2 : 1;
    },
    toggleGroup(groupName) {
      const index = this.topicsGroups.indexOf(groupName);
      if (index > -1) {
        this.topicsGroups.splice(index, 1);
      } else {
        this.topicsGroups.push(groupName);
      }
      this.filter.topicArr = this.filter.topicArr.filter(
        (item) => !item.isGroup
      );
    },
    onSelectOption(option) {
      const filtered = option.filter((item) => !item.isGroup);
      this.filter.topicArr = filtered;
    },
  },
  mounted: async function () {
    // var duration = moment.duration(moment().diff("2024-12-23"));
    // if(duration.asMonths() < 6) {
    // this.filter.startDate = moment("2024-12-23T00:00:00").format();
    // }else{
    //   this.filter.startDate = moment().subtract(6, "months").format();
    // }
    this.filter.startDate = moment().subtract(1, "months").format();

    this.filter.endDate = moment().format();
    this.getAllPlatformConfig();
    this.getConversationTopics();
    this.getAgents();
    this.getTeams();
    await this.getAllData();
  },
  computed: {
    ...mapGetters(["getBrandDetail"]),

    conversationTopicsFilter() {
      return this.conversationTopics.flatMap((group) => {
        const hasGroup = group.groupName;

        const headerGroup = hasGroup
          ? [{ isGroup: true, groupName: group.groupName }]
          : [];

        const items = group.topics.map((item) => ({
          ...item,
          groupName: group.groupName || null,
        }));

        return [...headerGroup, ...items];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.f-size-12 {
  font-size: 12px;
}

.date-container {
  max-width: 35%;
  margin: 0 0.5rem;
}

.row-container {
  border: 1px solid #dedede;
}

.stat-container {
  padding: 1rem;
  // border-radius: 4px;
  background: #e2dff3;
  color: #3c4b64;
  height: 100%;
  border-left: 5px solid #7160c4;
  .number {
    font-size: 1.75rem;
    font-weight: bold;
  }
}

.header-container {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}
::v-deep .input-flex-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  .custom-control-inline {
    width: 43% !important;
  }
}
::v-deep .dropdown-menu-right {
  min-width: 450px;
  max-height: 60vh;
  overflow-y: auto;
}
.submit-button {
  background-color: #5b57a5;
  color: white;
  border-radius: 4px;
}
#dropdown-filter {
  position: absolute;
  right: 0;
  top: 0;
}
.btn-export {
  padding: 0;
  text-decoration: underline;
}
.chart-h-heatmap > div {
  height: 100%;
}

::v-deep .multiselect__option {
  :has(.group-header) {
    padding: 0 !important;
  }
}
::v-deep .multiselect__element {
  :has(.group-header) {
    color: #35495e;
    background-color: #f0f0f0;
    padding: 0 !important;
    &:hover {
      background-color: #b41bb4;
      color: #ffffff;
    }

    &::after {
      display: none;
    }
  }

  :has(.group-item) {
    display: none !important;
  }

  span {
    padding-left: 10px;
  }
}

::v-deep .multiselect__tag {
  max-width: 300px;
}

::v-deep .multiselect__element {
  span {
    max-width: 390px;
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.group-header {
  padding: 12px 12px 15px 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: #f0f0f0;

  .group-icon {
    font-size: 10px;
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;
  }
}

.group-header:hover {
  background-color: #b41bb4;
}

.group-item,
.item {
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding-left: 10px;
}

@media (max-width: 720px) {
  .header-container {
    flex-direction: column-reverse;
  }
}
</style>
